import React from 'react';
import {Typography} from "@mui/material";
import LoggedLayout from "../../component/LoggedLayout";

 const CityView = () => {
    return (
        <LoggedLayout>
            <Typography>City view</Typography>
        </LoggedLayout>
    )
}

export default CityView